import i18n from '@/utils/i18n';

const state = {
  scrollY: 0,
  tableData: []
}

const mutations = {
  saveScrollY(state, data) {
    state.scrollY = data
  },
  saveTableData(state, data) {
    state.tableData = data
  }

}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

